import { Injectable } from '@angular/core';

interface Settings {
    appearance: 'legacy' | 'outline',
    decimalPlaces: number
}

@Injectable()
export class FormFieldDataService {
    
    DEBUG_MODE = false;
    DEBUG_OPTIONS = {
        forms: false,
        includeFormFieldMode: ['filter']//'standard' |'grid' | 'filter'
    } 

    /**
     * I settings vengono inizializzati con questi default, nel caso non venga chiamata
     * la funzione init
     */
    settings: Settings = {
        appearance: 'outline',
        decimalPlaces: 7
    }

    constructor() { }

    init = (settings: Settings) => {
        this.settings = settings;
    } 

    toggleDebugMode() {
        this.DEBUG_MODE = !this.DEBUG_MODE
    }
}
